const { logging } = require('@qlik-trial/g2-utils')
const path = require('path')
const os = require('os')

const { name, version } = require(path.join(process.cwd(), 'package.json'))

const storeDir  = name.startsWith('@') ? name.split('qaw-')[1] : name

function getLogger(scope = 'Global') {
  return logging.get({
    name: storeDir,
    version,
    hostname: os.hostname(),
    scope,
    logPath: path.resolve(process.env.ALLUSERSPROFILE || os.homedir(), 'QlikAlerting'),
  })
}

module.exports = getLogger
